import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Cart } from '@core/models/cart.model';
import { EmptyCartService } from '@core/services/cart/empty-cart.service';

@Component({
  standalone: true,
  selector: 'app-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss'],
  imports: [CommonModule, ReactiveFormsModule]
})
export class PromoCodeComponent {
  @Input() cart: Cart;

  code = new FormControl('');
  hasPromoCode: boolean | null = false;
  errorCoupon: string | null = null;
  isLoading: boolean | null = false;

  constructor(private emptyCartService: EmptyCartService) {}

  handlePromoCode() {
    this.errorCoupon = null;
    this.isLoading = true;
    this.emptyCartService
      .applyCoupon(this.code.value)
      .subscribe({
        error: err => {
          if (err.status == 404) {
            this.errorCoupon = 'Invalid promo code. Please try again.';
          } else if (err.status >= 400 && err.status < 500) {
            this.errorCoupon = err.error.string;
          }
        }
      })
      .add(() => {
        this.isLoading = false;
      });
  }
}
